import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc' // Updated Apollo HOC import
import '../DriverDetailNew.css'
import { InvoicesQuery } from "../../Queries"
import { Button, Col, Row, Table, Progress } from 'reactstrap'
import DatetimeRenderer from "../../../../../Material/DatetimeRenderer"
import Loader from "../../../../../Material/Loader"
import { CreateLatestInvoiceMutation } from "../../Mutations"
import withApolloClient from "../../../../../withApolloClient"
class InvoiceTab extends Component {
    constructor(props) {
        super(props)
    }
    createLatestInvoice = () => {
        if (this.props.driverId) {
            this.setState({ loading: true })
            let input = { driverId: this.props.driverId }

            this.props.apolloClient.mutate({
                mutation: CreateLatestInvoiceMutation,
                variables: { input }
            }).then((result) => {
                this.setState({ loading: false })
                if (result.data && result.data.createLatestInvoice && result.data.createLatestInvoice.ok) {
                    this.props.refetchInvoicesQuery()
                }
            })
        }
    };

    componentDidMount() {
        const { apolloClient } = this.props
    }

    render() {
        return (
            <div className="tab-container">
                {this.props.loading ? <Loader /> :
                    <Row id="invoices" className="info-container">
                        <Col xs={12} className="text-right pb-5">
                            <Button className="primary" onClick={this.createLatestInvoice}>Generate Latest Invoice</Button>
                        </Col>
                        <Col xs={12}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Invoice</th>
                                        <th>Sub Total</th>
                                        <th>Previous Balance</th>
                                        <th>Amount Due</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.invoices && this.props.invoices.edges && this.props.invoices.edges.length > 0 ?
                                        this.props.invoices.edges.map((invoice, i) => <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{invoice.node.startDate ? <DatetimeRenderer datetime={invoice.node.startDate} /> : "--"} &mdash; {invoice.node.endDate ? <DatetimeRenderer datetime={invoice.node.endDate} /> : "--"}</td>
                                            <td>${invoice.node.invoiceItemsTotal ? invoice.node.invoiceItemsTotal : 0}</td>
                                            <td>${invoice.node.previousBalance ? invoice.node.previousBalance : 0}</td>
                                            <td>${invoice.node.totalBalance ? invoice.node.totalBalance : 0}</td>
                                            <td>{invoice.node.uniqueId ? <a target="_blank" href={"/billing/invoice/download_invoice/?unique_id=" + invoice.node.uniqueId}><i class="fa fa-download" aria-hidden="true"></i></a> : "--"}</td>
                                        </tr>) :
                                        <tr><td colSpan="3" className="text-center">No Invoice Found</td></tr>
                                    }
                                    {this.props.loading && <tr><td colSpan={12}><Progress style={{ maxHeight: "5px" }} animated color="info" value="100" /></td></tr>}
                                    {this.props.invoices && this.props.invoices.pageInfo.hasNextPage &&
                                        <tr>
                                            <td colSpan={6}><Button style={{ paddingLeft: 0 }} onClick={this.props.loadMoreEntries} color="link linkHoverEffect">Show More <i className={"fa fa-caret-right"}></i></Button></td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
            </div>
        )
    }
}

export default graphql(InvoicesQuery, {
    options: ({ driverId }) => ({
        variables: {
            driverId: driverId,
            first: 10,
        },
    }),
    props: ({ data: { loading, invoices, fetchMore, variables } }) => (
        {
            loading,
            invoices,
            variables,
            refetchInvoicesQuery: () => {
                let currentLength =
                    invoices && invoices.edges && invoices.edges.length > 0
                        ? invoices.edges.length
                        : 30
                return fetchMore({
                    query: InvoicesQuery,
                    variables: {
                        ...variables,
                        first: currentLength,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newEdges = fetchMoreResult.invoices.edges
                        const pageInfo = fetchMoreResult.invoices.pageInfo
                        return {
                            invoices: {
                                edges: [...newEdges],
                                pageInfo,
                                searchTerm: previousResult.searchTerm,
                                __typename: previousResult.invoices.__typename,
                            },
                        }
                    },
                })
            },
            loadMoreEntries: () => {
                return fetchMore({
                    query: InvoicesQuery,
                    variables: {
                        cursor: invoices.pageInfo.endCursor,
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newEdges = fetchMoreResult.invoices.edges
                        const pageInfo = fetchMoreResult.invoices.pageInfo

                        return {
                            invoices: {
                                edges: [...previousResult.invoices.edges, ...newEdges],
                                pageInfo,
                                searchTerm: previousResult.searchTerm,
                                __typename: previousResult.invoices.__typename,
                            },
                        }
                    },
                })
            },
        }
    )
})(withApolloClient(InvoiceTab))